var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloadIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#96F",
    fillRule: "evenodd",
    transform: "matrix(1 0 0 -1 8 23)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    stroke: "#96F",
    strokeWidth: 0.3,
    d: "M8.348 5a.648.648 0 0 0-.486.184l-3.63 3.353a.704.704 0 0 0-.045 1c.253.272.738.292 1.016.044L7.63 7.3v5.523c0 .39.322.705.718.705a.712.712 0 0 0 .717-.705V7.3l2.428 2.28c.278.248.748.214 1.016-.044.282-.273.23-.75-.045-1l-3.63-3.353C8.69 5.056 8.587 5 8.348 5z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 2,
    rx: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.6ec678a8.svg";
export { ForwardRef as ReactComponent };